import { ACTION_TYPE, ModalAction } from '../../actions/modal'

export type State = {
  open: boolean
  shouldReloadPage?: boolean
}

export const initialState: State = {
  open: false,
  shouldReloadPage: false,
}

export function reducer(state = initialState, action: ModalAction): State {
  switch (action.type) {
    case ACTION_TYPE.TOGGLE_MODAL_FOLLOW: {
      return {
        ...state,
        open: action.isOpen,
        shouldReloadPage: action.shouldReloadPage,
      }
    }
    default:
      return state
  }
}
